/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
const a="20211215",d="ad43611b413b1d0a625293a3ce87543dde5c1fa2";export{a as buildDate,d as commitHash};
